import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum QuoteSecurityRight {
    CanAccess = 3000,
    Manage = 3001,
    // Mark = 3002,

    ManageViews = 3010,
    ManageOtherViews = 3011,
    ApproveQuotes = 3012,
}

export class QuoteSecurityModule extends BaseSecurityModule<QuoteSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Quotes,
            [
                { _id: QuoteSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: QuoteSecurityRight.Manage, name: 'Manage Quotes', basic: true },
                // { _id: QuoteSecurityRight.Mark, name: '[Deprecated] Mark as Won/Lost', basic: false },

                { _id: QuoteSecurityRight.ManageViews, name: 'Can Create/Edit Quotes Views', basic: true },
                { _id: QuoteSecurityRight.ManageOtherViews, name: 'Manage Other User Quotes Views', basic: false },
                { _id: QuoteSecurityRight.ApproveQuotes, name: 'Approve Quotes', basic: false },
            ] as SecurityRight<QuoteSecurityRight>[]
        );
    }
}
